"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormErrorStyled = exports.FormErrorStyles = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactUforms = require("react-uforms");

var _utils = require("../../../utils");

var _const = require("../../../const");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FormErrorChild = function FormErrorChild(_ref) {
  var name = _ref.name,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_reactUforms.FieldError, {
    name: name,
    className: className
  });
};

var FormErrorStyles = (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  padding-top: 10px;\n  display: flex;\n  line-height: 15px;\n"])), _const.Colors.danger, _const.TextSize.xs);
exports.FormErrorStyles = FormErrorStyles;
var FormErrorStyled = (0, _utils.styled)(FormErrorChild)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), FormErrorStyles, function (props) {
  return (0, _const.spacingStyle)(props);
});
exports.FormErrorStyled = FormErrorStyled;